export default "__VITE_ASSET__BjyPnSsx__"